import { Badge, ExternalLink } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';

const PAGE = 'features:storefront_widgets.pages.storefront_widgets_page' satisfies I18nPrefix;

export function InteractiveExampleLink({ link }: { link: string }) {
  return (
    <ExternalLink link={link}>
      <Badge variant="green" icon="view" interactive>
        {t(`${PAGE}.pdp.example_link`)}
      </Badge>
    </ExternalLink>
  );
}
